<div>
  <div [style.height]="height" [class]="inputClass" class="placeholder">
    @if (!iconClass) {
      <div class="text-center ph-5 c-gray">{{ text }}</div>
    } @else {
      <i class="text-center icon" [class]="iconClass"></i>
    }
  </div>
  @if (iconClass) {
    <div class="text-center c-text mt-10">
      {{ text }}
    </div>
  }
</div>
